import { APP_BRAND_NAMES, type AppBrand } from '../constants'
import { getAppBrand } from './getAppBrand'

export const getBrandName = (appBrand: AppBrand = getAppBrand()): string => {
  return APP_BRAND_NAMES[appBrand]
}
